import CreateIcon from '@/Icons/icon-dpo-create.svg';

const Create = ({ triggerStartCreateJourney }) => {
  return (
    <div id='create' className="flex flex-col flex-wrap bg-neutral-light border-2 border-neutral-dark cursor-pointer font-semibold text-center text-xs tablet:text-sm shadow-[shadow:var(--theme-card-shadow)] hover:ring-1 hover:ring-[color:var(--theme-link-border-color-4)] hover:border-[color:var(--theme-link-border-color-4)]">
        <button
          type="submit"
          className="flex flex-col w-full h-full"
          onClick={() => triggerStartCreateJourney()}
        >
          <div className="flex flex-col gap-xs items-center justify-center w-full bg-white p-lg laptop:flex-row">
            <div className="mx-3xs h-[4rem] w-[4rem]">
              <CreateIcon/>
            </div>
            <div className="laptop:text-left">
              <div className="text-2xl font-semibold">
                {Drupal.t('Create')}
              </div>
              <div className="text-xs font-semibold">
                {Drupal.t('your own design')}
              </div>
            </div>
          </div>
          <ul
            className="list-disc text-left pl-2xl pr-xl my-sm"
            dangerouslySetInnerHTML={{
              __html: Drupal.t(
                '<li>Use our <strong>Free</strong>, easy-to-use design tool</li><li>Create your own design or customise one of ours</li>'
              ),
            }}
          ></ul>
        </button>
    </div>
  );
};

export default Create;
